import api from './api';

export type DigestToolName =
  | 'summary'
  | 'attention'
  | 'standup'
  | 'burndown'
  | 'leaderboard'
  | 'forecast'
  | 'list';

export interface DigestResult {
  tool_name: string;
  renderer: string;
  success: boolean;
  data: any;
  error: string | null;
  execution_time: number;
  cached: boolean;
}

export interface DigestResponse {
  results: DigestResult[];
  tools_requested: string[];
  tools_available: string[];
}

export const digestService = {
  fetch: async (tools: DigestToolName[]): Promise<DigestResponse> => {
    const resp = await api.get('/work/digest', {
      params: { tools: tools.join(',') },
    });
    return resp.data;
  },
};
